import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Auth } from 'aws-amplify';
import { SetShowSpinner } from 'src/app/state-management/actions/app.actions';
import { AppState } from 'src/app/state-management/state/app.state';
import { ToasterService } from 'src/app/utils/toaster.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent implements OnInit {
  @Select(AppState.getVersion) version$;

  @Select(AppState.getShowSpinner) showSpinner$;

  public signUpForm: UntypedFormGroup;
  public validateCodeForm: UntypedFormGroup;
  private submitClick: boolean;
  private email: string;
  constructor(public formBuilder: UntypedFormBuilder,
    private store: Store,
    private router: Router,
    private toasterService: ToasterService,
  ) { }

  ngOnInit() {
    this.signUpForm = this.formBuilder.group({
      fullName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      password_confirm: ['', [Validators.required]],
      phone_number: ['', [Validators.required]],
      agreeTAndC: [true, [Validators.requiredTrue]]
    });
    this.validateCodeForm = this.formBuilder.group({
      email: [''],
      code: ['', [Validators.required]]
    });
    this.submitClick = false;
  }

  async onSignUp() {
    console.log('Inside signUp');
    this.store.dispatch(new SetShowSpinner(true));
    const { fullName, email, password, phone_number } = this.signUpForm.value;
    try {
      const { user } = await Auth.signUp({
        username: email,
        password,
        attributes: {
          name: fullName,
          email,
          phone_number,
          'custom:appName': 'netqSystems',
          'custom:role': 'endUser',
          'custom:dnsPrefix': 'apex'
        }
      });
      console.log(user);
      this.submitClick = true;
      this.validateCodeForm.patchValue({ email });
      this.store.dispatch(new SetShowSpinner(false));

    } catch (error) {
      console.log('error signing up:', error);
      this.store.dispatch(new SetShowSpinner(false));
      this.toasterService.presentToast('top', error.message, false, 'danger', 'ERROR', 5000);
    }
  }

  async confirm() {
    try {
      this.store.dispatch(new SetShowSpinner(true));
      console.log('Inside confirm');
      const { email, code } = this.validateCodeForm.value;
      const result = await Auth.confirmSignUp(email, code);
      console.log(result);
      this.toasterService.presentToast('top', 'Please enter login details', false, 'success', 'Sign up Success', 5000);
      this.store.dispatch(new SetShowSpinner(false));

      if (result === 'SUCCESS') this.router.navigate(['sign-in'], { state: { email: this.email } });
    } catch (error) {
      this.store.dispatch(new SetShowSpinner(false));
      this.toasterService.presentToast('top', error.message, false, 'danger', 'ERROR', 5000);
      console.log('error :>> ', error.message);

    }
  }
}